<template>

  <section class="section">

    <b-breadcrumb :items="[
        { text: 'Clienti', to: '/customers' },
        { text: data.companyName, href: '#', active: true }
        ]">
    </b-breadcrumb>

    <b-row>
      <b-col>
        <b-card no-body>
          <b-tabs card>
            <!-- Anagrafica -->
            <b-tab title="Anagrafica" active>
              <b-card-text>
                <div v-if="isViewData">
                  <table class="table striped">
                    <tr>
                      <th>Ragione sociale:</th>
                      <td>{{ data.companyName }}</td>
                    </tr>
                    <tr>
                      <th>Referente:</th>
                      <td>{{ data.firstName }} {{ data.lastName }}</td>
                    </tr>
                    <tr>
                      <th>Telefono:</th>
                      <td>{{ data.phone }}</td>
                    </tr>
                    <tr>
                      <th>E-mail:</th>
                      <td><a target="_blank" :href="'mailto:' + data.email">{{ data.email }}</a></td>
                    </tr>
                    <tr>
                      <th>P.IVA / C.F.:</th>
                      <td>{{ data.taxCode }}</td>
                    </tr>
                    <tr>
                      <th>Indirizzo:</th>
                      <td>{{ data.addressStreetName }}, {{ data.addressStreetNumber }}<br>
                        {{ data.addressTown }} ({{ data.addressState }}) - {{ data.addressZip }}
                      </td>
                    </tr>
                    <tr>
                      <th>Licenza:</th>
                      <td>{{ data.license }}</td>
                    </tr>
                    <tr>
                      <th>Scadenza licenza:</th>
                      <td>{{ data.licenseExpire }}</td>
                    </tr>
                    <tr>
                      <th>Email alert assenza dati:</th>
                      <td>
                        <div style="display: grid">
                          <span v-for="(item, index) in data.emailNoMeasures" :key="index">{{ item }}</span>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th>Email alert consumi a 0:</th>
                      <td>
                        <div style="display: grid">
                          <span v-for="(item, index) in data.emailZeroMeasures" :key="index">{{ item }}</span>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th>Email alert KPI:</th>
                      <td>
                        <div style="display: grid">
                          <span v-for="(item, index) in data.emailsKPI" :key="index">{{ item }}</span>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th>Email report:</th>
                      <td>
                        <div style="display: grid">
                          <span v-for="(item, index) in formatArray(data.emailsReport)" :key="index">{{ item }}</span>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th>ID EnerP:</th>
                      <td>
                        <div>
                          {{ data.enerpClientId }}
                        </div>
                      </td>
                    </tr>
                  </table>
                  <b-btn variant="danger" v-b-modal.modalDelete>Elimina</b-btn>
                  <router-link :to="editLink" class="btn btn-primary">Modifica</router-link>
                </div>

                <div class="row justify-content-center">
                  <form v-if="isCustomerEdit" role="form" v-on:submit.prevent="onSubmit"
                    class="col col-xs-12 col-lg-10 centered-col">
                    <div class="form-group">
                      <label class="control-label">Ragione sociale</label>
                      <input required type="text" class="form-control" v-model.trim="data.companyName">
                    </div>
                    <b-row>
                      <div class="col col-md-6">
                        <div class="form-group">
                          <label class="control-label">Nome referente</label>
                          <input required type="text" class="form-control" v-model.trim="data.firstName">
                        </div>
                      </div>
                      <div class="col col-md-6">
                        <div class="form-group">
                          <label class="control-label">Cognome referente</label>
                          <input required type="text" class="form-control" v-model.trim="data.lastName">
                        </div>
                      </div>
                    </b-row>
                    <b-row>
                      <div class="col col-md-6">
                        <div class="form-group">
                          <label class="control-label">Telefono</label>
                          <input required type="text" class="form-control" v-model.trim="data.phone">
                        </div>
                      </div>
                      <div class="col col-md-6">
                        <div class="form-group">
                          <label class="control-label">E-mail</label>
                          <input required type="email" class="form-control" v-model.trim="data.email">
                        </div>
                      </div>
                    </b-row>
                    <b-row>
                      <div class="col col-md-6">
                        <div class="form-group">
                          <label class="control-label">P. IVA / C.F.</label>
                          <input type="text" class="form-control" v-model.trim="data.taxCode">
                        </div>
                      </div>
                    </b-row>

                    <b-row>
                      <div class="col-md-5">
                        <div class="form-group">
                          <label class="control-label">Cerca indirizzo o azienda</label>
                          <gmap-autocomplete class="form-control" placeholder="Address" @place_changed="setPlace"
                            :options="autocompleteOptions" />
                        </div>
                      </div>
                    </b-row>

                    <b-row>
                      <div class=" col-xs-12 col-md-8">
                        <div class="form-group">
                          <label class="control-label">Indirizzo</label>
                          <input required type="text" class="form-control" v-model.trim="data.addressStreetName">
                        </div>
                      </div>
                      <div class=" col-xs-12 col-md-4">
                        <div class="form-group">
                          <label class="control-label">N°</label>
                          <input type="text" class="form-control" v-model.trim="data.addressStreetNumber">
                        </div>
                      </div>
                    </b-row>
                    <b-row>
                      <div class="col-md-3">
                        <div class="form-group">
                          <label class="control-label">Provincia
                          </label>
                          <select v-on:change="loadTowns()" required class="form-control" v-model="data.addressState">
                            <option v-for="state in states" v-bind:key="state.code" :value="state.code">{{ state.name }}
                            </option>
                          </select>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <label class="control-label">Città</label>
                          <select required class="form-control" v-model="data.addressTown">
                            <option v-for="town in towns" v-bind:key="town" :value="town">{{ town }}</option>
                          </select>
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="form-group">
                          <label class="control-label">CAP</label>
                          <input required type="text" class="form-control" v-model="data.addressZip">
                        </div>
                      </div>
                    </b-row>

                    <b-row>
                      <div class="col-md-6">
                        <div class="form-group">
                          <label class="control-label">Nazione</label>
                          <select class="form-control" v-model="data.addressCountry">
                            <option required value="AF">Afghanistan</option>
                            <option value="AL">Albania</option>
                            <option value="DZ">Algeria</option>
                            <option value="UM">Altre isole americane del Pacifico</option>
                            <option value="AD">Andorra</option>
                            <option value="AO">Angola</option>
                            <option value="AI">Anguilla</option>
                            <option value="AQ">Antartide</option>
                            <option value="AG">Antigua e Barbuda</option>
                            <option value="SA">Arabia Saudita</option>
                            <option value="AR">Argentina</option>
                            <option value="AM">Armenia</option>
                            <option value="AW">Aruba</option>
                            <option value="AU">Australia</option>
                            <option value="AT">Austria</option>
                            <option value="AZ">Azerbaigian</option>
                            <option value="BS">Bahamas</option>
                            <option value="BH">Bahrein</option>
                            <option value="BD">Bangladesh</option>
                            <option value="BB">Barbados</option>
                            <option value="BE">Belgio</option>
                            <option value="BZ">Belize</option>
                            <option value="BJ">Benin</option>
                            <option value="BM">Bermuda</option>
                            <option value="BT">Bhutan</option>
                            <option value="BY">Bielorussia</option>
                            <option value="BO">Bolivia</option>
                            <option value="BA">Bosnia ed Erzegovina</option>
                            <option value="BW">Botswana</option>
                            <option value="BR">Brasile</option>
                            <option value="BN">Brunei</option>
                            <option value="BG">Bulgaria</option>
                            <option value="BF">Burkina Faso</option>
                            <option value="BI">Burundi</option>
                            <option value="KH">Cambogia</option>
                            <option value="CM">Camerun</option>
                            <option value="CA">Canada</option>
                            <option value="CV">Capo Verde</option>
                            <option value="BQ">Caraibi olandesi</option>
                            <option value="CZ">C&egrave;chia</option>
                            <option value="EA">Ceuta e Melilla</option>
                            <option value="TD">Ciad</option>
                            <option value="CL">Cile</option>
                            <option value="CN">Cina</option>
                            <option value="CY">Cipro</option>
                            <option value="VA">Citt&agrave; del Vaticano</option>
                            <option value="CO">Colombia</option>
                            <option value="KM">Comore</option>
                            <option value="CD">Congo - Kinshasa</option>
                            <option value="CG">Congo-Brazzaville</option>
                            <option value="KP">Corea del Nord</option>
                            <option value="KR">Corea del Sud</option>
                            <option value="CI">Costa d&rsquo;Avorio</option>
                            <option value="CR">Costa Rica</option>
                            <option value="HR">Croazia</option>
                            <option value="CU">Cuba</option>
                            <option value="CW">Cura&ccedil;ao</option>
                            <option value="DK">Danimarca</option>
                            <option value="DG">Diego Garcia</option>
                            <option value="DM">Dominica</option>
                            <option value="EC">Ecuador</option>
                            <option value="EG">Egitto</option>
                            <option value="SV">El Salvador</option>
                            <option value="AE">Emirati Arabi Uniti</option>
                            <option value="ER">Eritrea</option>
                            <option value="EE">Estonia</option>
                            <option value="ET">Etiopia</option>
                            <option value="EZ">Eurozone</option>
                            <option value="FJ">Figi</option>
                            <option value="PH">Filippine</option>
                            <option value="FI">Finlandia</option>
                            <option value="FR">Francia</option>
                            <option value="GA">Gabon</option>
                            <option value="GM">Gambia</option>
                            <option value="GE">Georgia</option>
                            <option value="GS">Georgia del Sud e Sandwich australi</option>
                            <option value="DE">Germania</option>
                            <option value="GH">Ghana</option>
                            <option value="JM">Giamaica</option>
                            <option value="JP">Giappone</option>
                            <option value="GI">Gibilterra</option>
                            <option value="DJ">Gibuti</option>
                            <option value="JO">Giordania</option>
                            <option value="GR">Grecia</option>
                            <option value="GD">Grenada</option>
                            <option value="GL">Groenlandia</option>
                            <option value="GP">Guadalupa</option>
                            <option value="GU">Guam</option>
                            <option value="GT">Guatemala</option>
                            <option value="GG">Guernsey</option>
                            <option value="GN">Guinea</option>
                            <option value="GQ">Guinea Equatoriale</option>
                            <option value="GW">Guinea-Bissau</option>
                            <option value="GY">Guyana</option>
                            <option value="GF">Guyana francese</option>
                            <option value="HT">Haiti</option>
                            <option value="HN">Honduras</option>
                            <option value="IN">India</option>
                            <option value="ID">Indonesia</option>
                            <option value="IR">Iran</option>
                            <option value="IQ">Iraq</option>
                            <option value="IE">Irlanda</option>
                            <option value="IS">Islanda</option>
                            <option value="AC">Isola Ascensione</option>
                            <option value="CX">Isola Christmas</option>
                            <option value="IM">Isola di Man</option>
                            <option value="NF">Isola Norfolk</option>
                            <option value="AX">Isole &Aring;land</option>
                            <option value="IC">Isole Canarie</option>
                            <option value="KY">Isole Cayman</option>
                            <option value="CC">Isole Cocos (Keeling)</option>
                            <option value="CK">Isole Cook</option>
                            <option value="FO">Isole F&aelig;r &Oslash;er</option>
                            <option value="FK">Isole Falkland</option>
                            <option value="MP">Isole Marianne settentrionali</option>
                            <option value="MH">Isole Marshall</option>
                            <option value="PN">Isole Pitcairn</option>
                            <option value="SB">Isole Salomone</option>
                            <option value="TC">Isole Turks e Caicos</option>
                            <option value="VI">Isole Vergini Americane</option>
                            <option value="VG">Isole Vergini Britanniche</option>
                            <option value="IL">Israele</option>
                            <option value="IT" selected>Italia</option>
                            <option value="JE">Jersey</option>
                            <option value="KZ">Kazakistan</option>
                            <option value="KE">Kenya</option>
                            <option value="KG">Kirghizistan</option>
                            <option value="KI">Kiribati</option>
                            <option value="XK">Kosovo</option>
                            <option value="KW">Kuwait</option>
                            <option value="LA">Laos</option>
                            <option value="LS">Lesotho</option>
                            <option value="LV">Lettonia</option>
                            <option value="LB">Libano</option>
                            <option value="LR">Liberia</option>
                            <option value="LY">Libia</option>
                            <option value="LI">Liechtenstein</option>
                            <option value="LT">Lituania</option>
                            <option value="LU">Lussemburgo</option>
                            <option value="MG">Madagascar</option>
                            <option value="MW">Malawi</option>
                            <option value="MY">Malaysia</option>
                            <option value="MV">Maldive</option>
                            <option value="ML">Mali</option>
                            <option value="MT">Malta</option>
                            <option value="MA">Marocco</option>
                            <option value="MQ">Martinica</option>
                            <option value="MR">Mauritania</option>
                            <option value="MU">Mauritius</option>
                            <option value="YT">Mayotte</option>
                            <option value="MX">Messico</option>
                            <option value="FM">Micronesia</option>
                            <option value="MD">Moldavia</option>
                            <option value="MC">Monaco</option>
                            <option value="MN">Mongolia</option>
                            <option value="ME">Montenegro</option>
                            <option value="MS">Montserrat</option>
                            <option value="MZ">Mozambico</option>
                            <option value="MM">Myanmar (Birmania)</option>
                            <option value="NA">Namibia</option>
                            <option value="NR">Nauru</option>
                            <option value="UN">nazioni unite</option>
                            <option value="NP">Nepal</option>
                            <option value="NI">Nicaragua</option>
                            <option value="NE">Niger</option>
                            <option value="NG">Nigeria</option>
                            <option value="NU">Niue</option>
                            <option value="NO">Norvegia</option>
                            <option value="NC">Nuova Caledonia</option>
                            <option value="NZ">Nuova Zelanda</option>
                            <option value="OM">Oman</option>
                            <option value="NL">Paesi Bassi</option>
                            <option value="PK">Pakistan</option>
                            <option value="PW">Palau</option>
                            <option value="PA">Panam&aacute;</option>
                            <option value="PG">Papua Nuova Guinea</option>
                            <option value="PY">Paraguay</option>
                            <option value="PE">Per&ugrave;</option>
                            <option value="PF">Pochannelsia francese</option>
                            <option value="PL">Polonia</option>
                            <option value="PT">Portogallo</option>
                            <option value="PR">Portorico</option>
                            <option value="QA">Qatar</option>
                            <option value="HK">RAS di Hong Kong</option>
                            <option value="MO">RAS di Macao</option>
                            <option value="GB">Regno Unito</option>
                            <option value="CF">Repubblica Centrafricana</option>
                            <option value="MK">Repubblica di Macedonia</option>
                            <option value="DO">Repubblica Dominicana</option>
                            <option value="RE">Riunione</option>
                            <option value="RO">Romania</option>
                            <option value="RW">Ruanda</option>
                            <option value="RU">Russia</option>
                            <option value="EH">Sahara occidentale</option>
                            <option value="KN">Saint Kitts e Nevis</option>
                            <option value="LC">Saint Lucia</option>
                            <option value="MF">Saint Martin</option>
                            <option value="PM">Saint Pierre e Miquelon</option>
                            <option value="VC">Saint Vincent e Grenadines</option>
                            <option value="BL">Saint-Barth&eacute;lemy</option>
                            <option value="WS">Samoa</option>
                            <option value="AS">Samoa americane</option>
                            <option value="SM">San Marino</option>
                            <option value="SH">Sant&rsquo;Elena</option>
                            <option value="ST">S&atilde;o Tom&eacute; e Pr&iacute;ncipe</option>
                            <option value="SN">Senegal</option>
                            <option value="RS">Serbia</option>
                            <option value="SC">Seychelles</option>
                            <option value="SL">Sierra Leone</option>
                            <option value="SG">Singapore</option>
                            <option value="SX">Sint Maarten</option>
                            <option value="SY">Siria</option>
                            <option value="SK">Slovacchia</option>
                            <option value="SI">Slovenia</option>
                            <option value="SO">Somalia</option>
                            <option value="ES">Spagna</option>
                            <option value="LK">Sri Lanka</option>
                            <option value="US">Stati Uniti</option>
                            <option value="SS">Sud Sudan</option>
                            <option value="ZA">Sudafrica</option>
                            <option value="SD">Sudan</option>
                            <option value="SR">Suriname</option>
                            <option value="SJ">Svalbard e Jan Mayen</option>
                            <option value="SE">Svezia</option>
                            <option value="CH">Svizzera</option>
                            <option value="SZ">Swaziland</option>
                            <option value="TJ">Tagikistan</option>
                            <option value="TW">Taiwan</option>
                            <option value="TZ">Tanzania</option>
                            <option value="TF">Terre australi francesi</option>
                            <option value="PS">Territori palestinesi</option>
                            <option value="IO">Territorio britannico dell&rsquo;Oceano Indiano</option>
                            <option value="TH">Thailandia</option>
                            <option value="TL">Timor Est</option>
                            <option value="TG">Togo</option>
                            <option value="TK">Tokelau</option>
                            <option value="TO">Tonga</option>
                            <option value="TT">Trinidad e Tobago</option>
                            <option value="TA">Tristan da Cunha</option>
                            <option value="TN">Tunisia</option>
                            <option value="TR">Turchia</option>
                            <option value="TM">Turkmenistan</option>
                            <option value="TV">Tuvalu</option>
                            <option value="UA">Ucraina</option>
                            <option value="UG">Uganda</option>
                            <option value="HU">Ungheria</option>
                            <option value="UY">Uruguay</option>
                            <option value="UZ">Uzbekistan</option>
                            <option value="VU">Vanuatu</option>
                            <option value="VE">Venezuela</option>
                            <option value="VN">Vietnam</option>
                            <option value="WF">Wallis e Futuna</option>
                            <option value="YE">Yemen</option>
                            <option value="ZM">Zambia</option>
                            <option value="ZW">Zimbabwe</option>
                          </select>
                        </div>
                      </div>
                    </b-row>

                    <b-row>
                      <b-col>
                        <b-form-group label="Codice" description="Non utilizzare spazi o caratteri speciali">
                          <b-input required type="text" v-model="data.code" :disabled="canInsertCode"
                            pattern="[a-z]*" />
                        </b-form-group>
                      </b-col>
                    </b-row>

                    <b-row v-if="isNew">
                      <b-col>
                        <b-form-group label="Username Super Admin" :description="sausername+'-admin'">
                          <b-input-group append="-admin">
                            <b-input type="text" v-model="sausername" required />
                          </b-input-group>
                        </b-form-group>
                      </b-col>
                      <b-col>
                        <b-form-group label="Password Super Admin">
                          <b-input type="password" v-model="sapassword" required />
                        </b-form-group>
                      </b-col>
                    </b-row>

                    <b-row>
                      <b-col>
                        <b-form-group label="Licenza">
                          <b-input-group>
                            <b-input type="text" v-model="data.license" />
                            <b-btn class="mb-0" @click="generateGuid()">Genera codice</b-btn>
                          </b-input-group>
                        </b-form-group>
                      </b-col>
                      <b-col>
                        <b-form-group label="Scadenza licenza">
                          <b-input-group>
                            <date-pick v-model="data.licenseExpire" :inputAttributes="{
                                  class: 'form-control',
                                  style: 'border: 1px solid #ced4da; width: 100%;'
                                }" format="YYYY-MM-DD" />
                          </b-input-group>
                        </b-form-group>
                      </b-col>
                    </b-row>

                    <b-row>
                      <b-col :size="3">
                        <b-form-group label="Codice ENERP">
                          <b-input required type="text" v-model="data.enerpClientId" />
                          <b-btn @click="getEnerpClientId()">Ottieni ID cliente</b-btn>
                        </b-form-group>
                      </b-col>
                    </b-row>

                    <b-row>
                      <div class="col-md-12">
                        <div class="form-group">
                          <label class="control-label">Email alert (assenza dati)</label>
                          <textarea class="form-control" v-model="data.emailNoMeasuresStr"></textarea>
                        </div>
                      </div>
                    </b-row>

                    <b-row>
                      <div class="col-md-12">
                        <div class="form-group">
                          <label class="control-label">Email alert (dati a 0)</label>
                          <textarea class="form-control" v-model="data.emailZeroMeasuresStr"></textarea>
                        </div>
                      </div>
                    </b-row>

                    <b-row>
                      <div class="col-md-12">
                        <div class="form-group">
                          <label class="control-label">Email report</label>
                          <textarea class="form-control" v-model="data.emailsReport"></textarea>
                        </div>
                      </div>
                    </b-row>

                    <b-row>
                      <div class="col-md-12">
                        <div class="form-group">
                          <label class="control-label">Email KPI</label>
                          <textarea class="form-control" v-model="data.emailsKpiStr"></textarea>
                        </div>
                      </div>
                    </b-row>

                    <b-row>
                      <div class="col-md-12">
                        <div class="form-group">
                          <label class="control-label">Note</label>
                          <textarea class="form-control" v-model="data.notes"></textarea>
                        </div>
                      </div>
                    </b-row>

                    <b-row>
                      <div class="col right">
                        <a v-on:click="cancelEditing()" class="btn btn-secondary">Annulla</a>
                        <input type="submit" class="btn btn-success" value="Salva">
                      </div>
                    </b-row>
                  </form>
                </div>
              </b-card-text>
            </b-tab>

            <!-- Modelli -->
            <b-tab title="Modelli" v-if="guid">
              <b-card-text>
                <table class="table striped table-hover" v-if="models">
                  <thead>
                    <tr>
                      <th></th>
                      <th>Nome</th>
                      <th>Siti</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-bind:key="model.id" v-for="model in models" :class="'status-' + model.active">
                      <td>
                        <b-btn @click="getModel(model.id)" v-b-modal.submitModal class="edit-button"
                          style="background: none; color: #969696; border: none; :hover: #70b02b;">
                          <font-awesome-icon icon="cogs" />
                        </b-btn>
                      </td>
                      <td>{{ model.name }}</td>
                      <td>
                        <span class="badge badge-secondary" v-for="site in model.sites" v-bind:key="site.id">{{
                          site.name }}</span>
                      </td>
                      <td class="d-flex justify-content-end">
                        <b-btn variant="primary" @click="setParams(model)" v-b-modal.deleteModal
                          :disabled="model.sites.length > 0">
                          Elimina
                        </b-btn>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <b-btn variant="primary" @click="resetParams()" v-b-modal.submitModal>
                  <font-awesome-icon icon="plus" />
                  Nuovo modello
                </b-btn>
              </b-card-text>
            </b-tab>
          </b-tabs>
        </b-card>
      </b-col>
    </b-row>

    <b-modal id="submitModal" ref="modal" centered title="Modello" ok-title="Salva" ok-variant="success"
      @ok="submitModel">
      <label class="control-label">Name: </label>
      <input type="text" class="form-control" v-model="name" required />

      <b-form-group label="Siti" class="mt-3" v-if="sites.length > 1">
        <b-form-checkbox-group name="sites" v-model="selectedSites"
          :options="sites.map(s => { return { text: s.name, value: s.id } })">
        </b-form-checkbox-group>
      </b-form-group>
    </b-modal>

    <b-modal id="deleteModal" ref="modal" centered title="Conferma eliminazione" header-bg-variant="danger"
      cancel-title="Annulla" ok-title="Cancella" ok-variant="danger" @ok="deleteModel()">
      <p>Procedere con la cancellazione del modello <b>{{ name }}</b>?</p>
    </b-modal>

    <b-modal id="modalDelete" ref="modal" centered title="Conferma cancellazione" header-bg-variant="danger"
      @ok="goDelete">

      <p>Procedere con la cancellazione del cliente <b>{{ this.data.companyName }}</b>?
        <br><br>
        <small>I dati verranno comunque mantenuti nel database.</small>
      </p>
    </b-modal>
  </section>

</template>
<script>
import { mapState, mapActions } from 'vuex'
import customerMenu from "../Menu.vue"
import DatePick from 'vue-date-pick';
import 'vue-date-pick/dist/vueDatePick.css';


export default {
  name: 'CustomerEdit',
  created() {
    this.$store.commit("loading");
    if(this.$route.params.guid) {
      this.$store.dispatch('customers/get', this.$route.params.guid).then( (data) => {
        this.data = Object.assign({}, data);
        
        this.data.emailNoMeasuresStr = data.emailNoMeasures.join('\n')
        this.data.emailZeroMeasuresStr = data.emailZeroMeasures.join('\n')
        this.data.emailsKpiStr = data.emailsKPI.join('\n')

        if(data && data.emailsReport && data.emailsReport.length > 0) {
          this.data.emailsReport = data.emailsReport.join("\n");
        }

        if(data && data.addressState) {
          this.$store.dispatch('utils/towns', data.addressState);
        }
      })
    } else {
      this.$store.commit('customers/reset');
      this.$store.commit('utils/resetTowns');
    }

    this.$store.dispatch('utils/states');
    this.$store.dispatch('customers/list').then(data => {
      this.customers = [ ...data ];
    })
    this.loadModels();
    this.$store.commit("stopLoading");
  },
  props: ['currentPage'],
  components: {
    customerMenu, DatePick
  },
  data() {
      return {
        models: [],
        customers: [],
        dataModel: {
          name: null,
          sites: null,
        },
        showForm: false,
        isImageModalActive: true,
        sausername: "",
        sapassword: "",
        data: {
          license: null
        },
        autocompleteOptions: {
          componentRestrictions: {
            country: [
              'it',
            ],
          },
          fields: ['address_components', 'geometry'],
        },
        selectedSites: [],
        id: null,
        name: null,
      }
  },
  mounted() {
    this.data.addressCountry = "IT"
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    emailNoMeasures() {
      return this.data.emailNoMeasures.join('\n')
    },
    emailZeroMeasures() {
      return this.data.emailZeroMeasures.join('\n')
    },
    sites() {
      // return this.user.sites.filter(item => item.id == 1);
      return this.user.sites;
    },
    feedback: {
      get() {
        return this.$store.state.models.editFeedback
      },
      set(value) {
        this.$store.dispatch('customers/alert', value);
      },
    },
    canInsertCode() {
      return !!this.$route.params.guid
    },
    guid() { return this.$route.params.guid },
    isNew() { return ! this.guid },
    editLink() { return "/customers/" + this.$route.params.guid + "/edit" },
    isViewData() { return this.currentPage == "view" },
    isCustomerEdit() { return this.currentPage == "customerEdit" },
    isUsers() { return this.currentPage == "users" },
    states() {
      return this.$store.state.utils.states
    },
    towns() {
      return this.$store.state.utils.towns
    }
  },
  methods: {
    async getEnerpClientId() {
      if (!this.data.taxCode) {
        this.$notify({
          type: "error",
          text: "Inserire la Partita IVA",
          title: 'Errore',
        });
        return
      }
      const result = await this.$store.dispatch('customers/getEnerpClientId', this.data.taxCode)
      if (result.code != 1) {
        this.$notify({
          type: "error",
          text: result.message,
          title: 'Errore',
        });
        return
      }

      if (!result.data) {
        this.$notify({
          type: "warn",
          text: "Cliente non trovato",
          title: 'Errore',
        });
        return
      }

      this.data.enerpClientId = result.data;
    },
    formatArray(emails) {
      if(emails && emails.length > 0) {
        const array = emails.split("\n");
        return array;
      }
      return "";
    },
    resetParams() {
      this.dataModel = {};
      this.name = null;
      this.id = null;
      this.selectedSites = [];
    },
    setParams(model) {
      this.name = model.name;
      this.id = model.id;
    },
    deleteModel() {
      if(!this.id) {
        return;
      }
      const parameters = {
        guid: this.guid,
        id: this.id
      }
      this.$store.commit("loading")
      this.$store.dispatch('models/delete', parameters).then( () => {
        this.$store.commit("stopLoading");  
        this.loadModels();   
          this.$notify({
            type: "success",
            text: "Eliminazione completata",
            title: 'Successo'
          });     
        // this.$toasted.show('Eliminazione completata', { duration: 3000, icon : 'success', theme: "bubble" })
      })
    },
    loadModels() {
      if(this.guid) {
        this.$store.dispatch('models/list', this.guid).then( (models) => {
          this.models = models;
          this.$store.commit("stopLoading");        
        });
      }
    },
    getModel(id) {
      const correctModel = this.models.find(item => item.id == id);
      this.name = correctModel.name;
      this.id = id;
      this.selectedSites = correctModel.sites.map( s => s.id);
      if(this.selectedSites.length == 0) {
        this.selectedSites = this.sites;
      }
    },
    submitModel(evt) {
      evt.preventDefault();
      if(! this.name) {
        // this.$toasted.show('Inserire nome', { duration: 2000, icon : 'warning', theme: "bubble" })
        this.$notify({
          type: "error",
          text: "Inserire nome",
          title: 'Errore',
        });
        return;
      } else this.dataModel.name = this.name;

      if(this.sites.length == 1) {
        this.dataModel.sites = [];
        this.dataModel.sites.push(this.sites[0].id);
      } else this.dataModel.sites = this.selectedSites;
      
      if(this.dataModel.sites && this.dataModel.sites.length < 1) {
        // this.$toasted.show('Selezionare almeno un sito', { duration: 2000, icon : 'warning', theme: "bubble" })
        this.$notify({
          type: "error",
          text: "Selezionare almeno un sito",
          title: 'Errore',
        });
        return;
      }

      let parameters = {
        guid: this.guid,
        data: this.dataModel
      }
      this.$store.commit("loading");
      if(this.id > 0) {
        parameters.id = this.id;
        this.$store.dispatch(`models/edit`, parameters).then( (data) => {
          this.checkAndStopLoading(data);
        })
      } else {
        this.$store.dispatch(`models/add`, parameters).then( (data) => {
          this.checkAndStopLoading(data);
        })
      }    
    },
    checkAndStopLoading(data) {
      if(data.code == -1) {
        this.$store.commit("stopLoading");
        // this.$toasted.show(data.message, { duration: 4000, icon : 'warning', theme: "bubble" })
        this.$notify({
          type: "error",
          text: data.message,
          title: 'Errore',
        });
        return;
      }
      this.$store.commit("stopLoading");
      this.$nextTick(() => {
        this.$bvModal.hide('submitModal');
      })
      this.loadModels(); 
      this.$notify({
        type: "success",
        text: "Modello salvato",
        title: 'Successo'
      }); 
      //this.$toasted.show('Modello salvato', { duration: 3000, icon : 'check', theme: "bubble" });
    },
    setPlace(place) {
      let country = place.address_components.filter(address_component => ["country"].some(word => ~address_component.types.indexOf(word)));
      let state = place.address_components.filter(address_component => ["administrative_area_level_2"].some(word => ~address_component.types.indexOf(word)));
      let city = place.address_components.filter(address_component => ["administrative_area_level_3"].some(word => ~address_component.types.indexOf(word)));
      let zip = place.address_components.filter(address_component => ["postal_code"].some(word => ~address_component.types.indexOf(word)));
      let streetNumber = place.address_components.filter(address_component => ["street_number"].some(word => ~address_component.types.indexOf(word)));
      let streetName = place.address_components.filter(address_component => ["route"].some(word => ~address_component.types.indexOf(word)));

      this.data.addressCountry = country.length > 0 && country[0].short_name !== 'undefined' ? country[0].short_name : null
      this.data.addressState = state.length > 0 && state[0].short_name !== 'undefined' ? state[0].short_name : null;
      this.data.addressTown = city.length > 0 && city[0].short_name !== 'undefined' ? city[0].short_name : null;
      this.data.addressZip = zip.length > 0 && zip[0].short_name !== 'undefined' ? zip[0].short_name : null;
      this.data.addressStreetNumber = streetNumber.length > 0 && streetNumber[0].short_name !== 'undefined' ? streetNumber[0].short_name : null;
      this.data.addressStreetName = streetName.length > 0 && streetName[0].short_name !== 'undefined' ? streetName[0].short_name : null;

      this.loadTowns();
    },
    goDelete() {
      this.$store.dispatch('customers/delete', this.guid).then( () => {
        this.$notify({
          type: "success",
          text: "Cliente eliminato",
          title: 'Successo'
        }); 
        // this.$toasted.show('Cliente eliminato', { duration: 3000, icon : 'check', theme: "bubble" })
        this.$router.push('/customers')
      });
    },
    generateGuid() {
      let result, i, j;
      result = '';
      for(j=0; j<32; j++) {
        if( j == 8 || j == 12 || j == 16 || j == 20)
          result = result + '-';
        i = Math.floor(Math.random()*16).toString(16).toUpperCase();
        result = result + i;
      }
      this.data.license = result;
    },
    loadTowns() {
      this.$store.dispatch('utils/towns', this.data.addressState);
    },
    cancelEditing() {
      this.$router.push('/customers')
    },
    onSubmit (evt) {
      evt.preventDefault();
      this.$store.commit("loading")

      let params = {}
      let action = this.isNew ? "customers/add" : "customers/edit"
      if(this.isNew) {
        params.data = this.data, this.saveObj,
        params.data.code = this.data.code.toLowerCase();
        params.superAdminUsername = this.sausername + "-admin";
        params.superAdminPassword = this.sapassword;

        if(this.customers.find(item => item.code == params.data.code)) {
          this.$notify({
            type: "error",
            text: "Codice cliente già esistente",
            title: 'Errore'
          });
          this.$store.commit("stopLoading");
          return;
        }
      } else {
        params = this.data
      }
            
      if (this.data.emailNoMeasuresStr) {
        params.emailNoMeasures = this.data.emailNoMeasuresStr.split('\n').filter(e => e.length > 0)  
      } else {
        params.emailNoMeasures = []
      }
      if (this.data.emailZeroMeasuresStr) {
        params.emailZeroMeasures = this.data.emailZeroMeasuresStr.split('\n').filter(e => e.length > 0)
      } else {
        params.emailZeroMeasures = []
      }
      if (this.data.emailsKpiStr) {
        params.emailsKPI = this.data.emailsKpiStr.split('\n').filter(e => e.length > 0)
      } else {
        params.emailsKPI = []
      }
      

      let emailsReport = [];
      
      if(this.data.emailsReport && this.data.emailsReport.length > 0) {
        emailsReport = this.data.emailsReport.split("\n");
      }
      params.emailsReport = emailsReport;

      this.$store.dispatch(action, params).then((data) => {
        this.$notify({
          type: "success",
          text: "Dati salvati",
          title: 'Successo'
        });

        this.$router.push('/customers');
      });
      
      this.$store.commit("stopLoading");
    }
  }
}
</script>

<style scoped>
  textarea.form-control {
    height: 100px;
  }
  span.has-error {
      color: #FF4444;
      font-size: 13px;
  }
  .edit-button {
    background: none; 
    color: #969696; 
    border: none;
  }
  .edit-button:hover {
    color: #70b02b !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Admin/Customers/Edit.vue